<template>
  <div class="privacy">
    <div>プライバシーポリシー</div>
  </div>
</template>

<script>
export default {
  name: 'Privacy'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue